import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIphoneDuo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconIphoneDuo"><Path fillRule="evenodd" clipRule="evenodd" d="M17.25 2C18.7688 2 20 3.23122 20 4.75V19.25C20 20.7688 18.7688 22 17.25 22H4V2H17.25ZM16 5C15.4477 5 15 5.44772 15 6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6C17 5.44772 16.5523 5 16 5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconIphoneDuo;
